import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Col, Button, Alert } from 'react-bootstrap';
import EditSalaryLayouts from '../../components/EditSalaryLayout.jsx';
import './edit-salary.css';
import { FaUserLarge } from "react-icons/fa6";
import { Link, useNavigate } from 'react-router-dom';

export default function EditSalary() {
  const { id } = useParams(); // Employee ID from URL
  const [employee, setEmployee] = useState(null);
  const [salary, setSalary] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const response = await fetch(`https://backend.ems.uk.hiradentallab.com/api/user/user/${id}`);
        const data = await response.json();
        setEmployee(data);
        setSalary(data.salary); // Initialize with current salary
      } catch (error) {
        console.error('Error fetching employee:', error);
      }
    };

    fetchEmployee();
  }, [id]);

  const handleSalaryUpdate = async () => {
    try {
      const response = await fetch(`https://backend.ems.uk.hiradentallab.com/api/user/updateSalary/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ salary })
      });
      if (response.ok) {
        setShowAlert(true); // Show success alert
        setTimeout(() => {
          setShowAlert(false); // Hide alert after a delay
          navigate('/basic-salary');
        }, 2000); // 2-second delay before redirect
      } else {
        console.error('Failed to update salary');
      }
    } catch (error) {
      console.error('Error updating salary:', error);
    }
  };

  return (
    <EditSalaryLayouts>
      <h1 className='edit-salary-title'><FaUserLarge /> For Employee "{employee?.name || 'Loading...'}"</h1>
      <hr />
      {showAlert && (
        <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
          Salary updated successfully!
        </Alert>
      )}
      <div className='edit-salary-container'>
        <Form.Group as={Col} xs={12} md={6} controlId="formGridName">
          <Form.Label>Salary<span className='required'>*</span>:</Form.Label>
          <Form.Control
            type="text"
            name="salary"
            required
            placeholder="--00000--"
            className="form-control"
            value={salary}
            onChange={(e) => setSalary(e.target.value)}
          />
        </Form.Group>
        <Button onClick={handleSalaryUpdate} className='btn btn-primary update-salary-btn'>Update Salary</Button>
      </div>
    </EditSalaryLayouts>
  );
}
